import { Component, HostBinding } from '@angular/core';

@Component({
  standalone: false,
  selector: 'campus-touch-target, [touch-target]',
  template: '',
  styleUrls: ['./touch-target.component.scss'],
})
export class TouchTargetComponent {
  @HostBinding('class')
  defaultClasses = ['touch-target', 'absolute', 'block', 'inset-bs-1/2', 'transform', '-translate-y-1/2', 'w-full'];

  @HostBinding('style.appearance')
  appearance = 'none';
}
